import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/skills", label: "Standing", end: true },
  { to: "/skills/focus", label: "Focus", end: false },
  { to: "/skills/journey", label: "Journey", end: false },
  { to: "/skills/level", label: "Level", end: false },
];

/** Segmented control for the three /skills sub-views. URL-addressable so
 *  deep links + back/forward work. */
export function SkillsTabs() {
  return (
    <div
      role="tablist"
      className="flex gap-1 rounded-xl border border-border bg-surface p-1"
    >
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          role="tab"
          className={({ isActive }) =>
            [
              "flex-1 text-center text-sm font-medium rounded-lg py-2 transition",
              isActive
                ? "bg-accent/15 text-accent"
                : "text-text-muted hover:text-text hover:bg-text/5",
            ].join(" ")
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
